import { Autocomplete, Backdrop, Button, Dialog, Grid, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalTable from "../../../../../components/utils/modalTable/modalTable";
import CashCloseTable from "../../../../../components/utils/modalTable/cashCloseTable";
import { date } from "yup";
import { Print } from "@mui/icons-material";
import { onPressButton, setThermalData } from "../../../../../components/hooks/printPdf/thermalData";
import { useNavigate } from "react-router-dom";
import OtToOtTransferTable from "../../../../../components/utils/modalTable/otToOtTransferTable";
import CustomTable from "../../reports/customTable";

const TransferRequest = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [rowData, setRowData] = useState(null)
  const [supplier, setSupplier] = useState([]);
  const navigate = useNavigate()
  const[salesLines , setSalesLines] = useState([])
  const [open , setOpen] = useState(false)
  const [companyData , setCompanyData] = useState([])
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
    const roleId = localStorage.getItem("role_id")
    const outletName = localStorage.getItem('outlet_name')
    const outletId = localStorage.getItem('outlet_id')
  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().format(),
    // fromDate : moment().subtract(1 , 'months').format(),
    toDate :  moment().format()
  })
  const[cust, setCust] = useState(null)
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [docNo, setDocNo] = useState('')

  const fixedOutlet = { id: outletId, fullname: outletName };
  const onEdit = (e) => {
    console.log(e.row)
    setSalesLines(e.row.closing_expences_lines)
    setRowData(e.row)
    setOpen(true)
  }
  console.log(salesLines,"closing_expences_lines")
  function handleTransferApproved(row) {
    setSelectedRow(row.docNo,);
    setOpenDialog(true);
}

const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "date1",
    headerName: "Date",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "docNo",
    headerName: "Doc NO",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field:"fromOutlet",
    headerName: "From Outlet Name",
    minWidth: 200,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "toOutlet",
    headerName: "To Outlet Name",
    minWidth: 200,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "mobile",
    headerName: "Mobile",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "approve",
    headerName: "Approve",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => (
      <Button
        variant="contained"
        color="primary"
        size="small"
        sx={{ borderRadius: '120px',fontSize: 10 }} 
        onClick={() => handleTransferApproved(params.row)}
        // onClick={() => handleApprove(params.row)}
      >
        Approve
      </Button>
    ),},
  // {
  //   field: "expences_amount",
  //   headerName: "Expences Amount",
  //   minWidth: 130,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "closing_balance",
  //   headerName: "Closing Balance",
  //   minWidth: 130,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "tot",
  //   headerName: "Total",
  //   minWidth: 130,
  //   headerAlign: "center",
  //   align: "right",
  //   sortable: false,
  //   renderCell: (params) => (
  //     <strong>{params.value}</strong>
  //   ),
  // },
  {
    field: "view",
    headerName: "View",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
    disableExport: true ,
    renderCell: (params) => {
      return (
        <div>
          <IconButton size="small" onClick={() => onEdit(params)}><VisibilityIcon /></IconButton>
            {/* <IconButton size="small" onClick={()=>handleThermal(params.row)}><Print sx={{fontSize: 18}}/></IconButton> */}

        </div>
        
      );
    },
  },
]
// useEffect(() => {
//   axios.get(`/v1/outlet/info/${outletId}`)
//   .then((res) => {console.log(res.data);setCompanyData(res.data)})
//   .catch((err) => {console.log(err)})
//     },[])
  function handleThermal(e){
    console.log('Working!',e)
    console.log(e)
    const textData = {
      tot:e.tot,
      date:e.documentDate,
      employee:e.salesManName,
      opening_balance:e.opening_balance,
      expences_amount:e.expences_amount
    }
    const tableData = _.map(e.closing_expences_lines, ((val , idx)=>({ 
      sno:++idx,
     denomination:val.denomination,
     count:val.count,
     total:val.total
    })))
    console.log(tableData)
    console.log(textData)
   
    dispatch(setThermalData({
      tableData : tableData,
      TotalData : textData,
      companyInfo:cust
    }))      
    dispatch(onPressButton())
    const name = `ExpenseBill`
    navigate(`/expenseClose/${name}`)  
   
        }
        console.log(cust)
const rows = _.map(data,(val,idx)=>({
  id: val.id,
  sno: idx+1,
  // date1 : val.docdate,
  date1 : moment(val.docdate).format("DD-MM-YYYY"),
  docNo:val.docno,
  fromOutlet : val.from_outlet_fullname,
  toOutlet:val.to_outlet_fullname,
  otCode:val.code,
  party : val.fullname,
  amount:val.amount,
  mobile:val.mobile,
  tot: parseFloat(val.amount).toFixed(2),
  closing_expences_lines:val.outlet_to_outlet_transfer_lines,
  closing_balance:val.closing_balance,
  documentDate:moment(val.date).format("DD-MM-YYYY"),
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
console.log(rows,"rows");

useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      total += parseFloat(val.amount);
  });
  setTotalAmount(total.toFixed(2));
}, [data]);
const tableHeadData = [
  { id:1, label: "S No" },
  { id:2, label: "Date" },
  { id:3 , label:"barcode"},
  { id:4 , label : "Product Name"},
  { id:5, label:"QTY"},
  { id:6 , label:"total"},
];
console.log(salesLines,)
const tableBodyData = _.map(salesLines, (val,idx) => ({
  id:idx,
  sNo:idx+1,
  count:val.qty,
  denomination:val.barcode,
  proName: val.pro_name,
  date:moment(val.docdate).format("DD-MM-YYYY"),
  total:val.mrp,
}))
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        setSupplier(res.data);
        _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
function handleSalesReturn(){
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
      customer: cust!==null ? cust.id : fixedOutlet.id
  }
  axios.post('/v1/reports/outlet/to/outlet/transfer/unowned', postData)
  .then(res=>{
    setData(res.data)
    setPageCount(res.data.length)
    console.log(res.data,"data");
    
  })
  .catch(err=>{
    // dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
    setData([])
  })
}

// const handleApprove = (row) => {
//   // Ensure closing_expences_lines exists and is an array
//   const closingExpencesLines = row?.closing_expences_lines;

//   if (Array.isArray(closingExpencesLines)) {
//     // Extract barcodes and product IDs from closing_expences_lines
//     const barcodeData = closingExpencesLines.map((line) => ({
//       barcode: line.barcode,
//       prodid: line.prodid, // Assuming prodid is the product ID
//     }));

//     // Define the payload, including the barcodes
//     const payload = {
//       docno: selectedRow, // Adjust if docno is nested differently
//       outletid: outletId, // Assuming 'row' has the 'outletid' property
//       is_owned: true,
//       is_approved: true,
//       is_approved_date: new Date().toISOString().split('T')[0], // Current date in YYYY-MM-DD format
//       items: barcodeData, // Adding items (barcode and prodid) to the payload
//     };

//     console.log("Docno:", selectedRow);
//     console.log("Payload:", payload);

//     // Send the payload in the API request
//     axios
//       .post('/v1/outlet_to_outlet_transfer/change/isowned', payload)
//       .then((res) => {
//         dispatch(setSnackbar(true, "success", "Transfer approved successfully!"));
//         handleSalesReturn(); // Refresh data after approval
//         setOpenDialog(false);
//       })
//       .catch((err) => {
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//         setOpenDialog(false);
//       });
//   } else {
//     // Log the row and closing_expences_lines if they are not as expected
//     console.error("closing_expences_lines is undefined or not an array", row);
//   }
// };



const handleApprove = (row) => {

    // Define the payload based on the provided data structure
    const payload = {
        docno:selectedRow, // Adjust if docno is nested differently
        outletid: outletId, // Assuming 'row' has the 'outletid' property
        // is_owned: true,
        is_approved: true,
        is_approved_date: new Date().toISOString().split('T')[0], // Current date in YYYY-MM-DD format
        // prodid:row.closing_expences_lines.prodid
      };

    axios.post('/v1/outlet_to_outlet_transfer/change/isowned', payload)
      .then((res) => {
        dispatch(setSnackbar(true, "success", "Transfer approved successfully!"));
        handleSalesReturn(); // Refresh data after approval
        setOpenDialog(false);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
        setOpenDialog(false);

      });
  };
  
console.log(data)
  useEffect(() => {
    getSupplierData();
  }, []);
  
  useEffect(()=>{
    if( dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleSalesReturn()
      console.log('Vanthuden')
    }
  },[rowsPerPage, page, dateLimit, cust])
  console.log(roleId != 2 )
  return (
    <Fragment>
      <Helmet><title>Warehouse Transfer Request</title></Helmet>
      <Typography variant="h6">Warehouse Transfer Request</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            value={cust}
            options={supplier}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname}
            disabled={roleId != 1 && roleId != 2} 
            renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              disabled={roleId != 1 && roleId != 2}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              disabled={roleId != 1 && roleId != 2}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props}/>
      <Backdrop open={open} sx={{zIndex:9999}}>
        <OtToOtTransferTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData}/>
      </Backdrop>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
      <Grid className='bg-white p-5'>
            <Typography variant='h5'>Are you sure you want to Approve?</Typography>
            <Grid className='flex justify-center mt-5'>
                <Button variant='outlined' onClick={() => setOpenDialog(false)}>Cancel</Button>
                <div>
                    <Button
                        variant='contained'
                        sx={{ marginInline: 2, backgroundColor: 'red !important' }}
                        onClick={handleApprove} 
                    >
                        Confirm
                    </Button>
                </div>
            </Grid>
        </Grid>
             
            </Dialog>
    </Fragment>
  );
};

export default memo(TransferRequest);
